/**
 * Реестр идентификаторов страниц с сохранёнными фильтрами.
 * Использует общий файл shared/savedFilterPageKeys.json для синхронизации с сервером.
 */
import data from '../../../shared/savedFilterPageKeys.json';

export const PAGE_KEYS = data.PAGE_KEYS;

export default PAGE_KEYS;
